import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldAlt, faCookie, faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';
import './PrivacyPolicyPage.css';

const PrivacyPolicyPage: React.FC = () => {
  return (
    <div className="privacy-page">
      {/* Header */}
      <section className="privacy-header">
        <div className="privacy-header-container">
          <FontAwesomeIcon icon={faShieldAlt} className="privacy-header-icon" />
          <h1 className="privacy-header-title">Privacy & Cookie Policy</h1>
          <p className="privacy-header-date">Ultimo aggiornamento: 13 febbraio 2026</p>
        </div>
      </section>

      {/* Content */}
      <section className="privacy-content">
        <div className="privacy-container">
          
          {/* Privacy Policy */}
          <div className="privacy-section">
            <div className="privacy-icon-header">
              <FontAwesomeIcon icon={faShieldAlt} />
              <h2>Privacy Policy</h2>
            </div>

            <div className="privacy-block">
              <h3>1. Titolare del Trattamento</h3>
              <p>
                Il Titolare del trattamento dei dati è il <strong>Dr. Gianfranco Mattina</strong>, 
                con studio in Via Capo dell'Acqua 6 (Piazza Duomo), Partinico.
              </p>
              <p>
                <strong>Contatti:</strong>
                <br />
                Telefono: <a href="tel:+393701627395">+39 370 162 7395</a> / <a href="tel:+390917669253">+39 091 766 9253</a>
                <br />
                Email: <a href="mailto:centrodiotorino.mattina@gmail.com">centrodiotorino.mattina@gmail.com</a>
              </p>
            </div>

            <div className="privacy-block">
              <h3>2. Principi del Trattamento</h3>
              <p>
                Il trattamento dei dati personali avviene nel rispetto dei principi di:
              </p>
              <ul>
                <li><strong>Liceità, correttezza e trasparenza:</strong> i dati sono trattati in modo lecito, corretto e trasparente nei confronti dell'interessato</li>
                <li><strong>Limitazione della finalità:</strong> i dati sono raccolti per finalità determinate, esplicite e legittime</li>
                <li><strong>Minimizzazione dei dati:</strong> i dati sono adeguati, pertinenti e limitati a quanto necessario</li>
                <li><strong>Esattezza:</strong> i dati sono esatti e, se necessario, aggiornati</li>
                <li><strong>Limitazione della conservazione:</strong> i dati sono conservati per il tempo strettamente necessario</li>
                <li><strong>Integrità e riservatezza:</strong> i dati sono trattati in modo da garantirne la sicurezza</li>
              </ul>
            </div>

            <div className="privacy-block">
              <h3>3. Tipologia di Dati Raccolti</h3>
              <p>
                I dati personali che possiamo raccogliere includono:
              </p>
              <ul>
                <li><strong>Dati identificativi:</strong> nome, cognome, codice fiscale</li>
                <li><strong>Dati di contatto:</strong> indirizzo email, numero di telefono, indirizzo postale</li>
                <li><strong>Dati sanitari:</strong> in qualità di centro medico, trattiamo dati relativi alla salute (art. 9 GDPR) necessari per l'erogazione delle prestazioni sanitarie</li>
                <li><strong>Dati di navigazione:</strong> indirizzo IP, browser utilizzato, pagine visitate</li>
              </ul>
            </div>

            <div className="privacy-block">
              <h3>4. Finalità del Trattamento</h3>
              <p>
                I dati personali sono trattati per le seguenti finalità:
              </p>
              <ul>
                <li><strong>Gestione delle prenotazioni:</strong> per programmare e gestire gli appuntamenti</li>
                <li><strong>Erogazione delle prestazioni sanitarie:</strong> per fornire consulenze e trattamenti medici</li>
                <li><strong>Gestione amministrativa:</strong> per la fatturazione e la contabilità</li>
                <li><strong>Obblighi di legge:</strong> per adempiere agli obblighi previsti da leggi, regolamenti e normative</li>
                <li><strong>Comunicazioni informative:</strong> per inviare comunicazioni relative ai servizi offerti (previo consenso)</li>
                <li><strong>Miglioramento del sito:</strong> per analizzare l'utilizzo del sito e migliorare l'esperienza utente</li>
              </ul>
            </div>

            <div className="privacy-block">
              <h3>5. Base Giuridica del Trattamento</h3>
              <p>
                Il trattamento dei dati si basa su:
              </p>
              <ul>
                <li><strong>Esecuzione del contratto:</strong> per fornire i servizi richiesti</li>
                <li><strong>Consenso dell'interessato:</strong> per finalità che richiedono un consenso esplicito</li>
                <li><strong>Obbligo di legge:</strong> per adempiere a obblighi normativi (es. conservazione documentazione sanitaria)</li>
                <li><strong>Interesse vitale:</strong> per proteggere gli interessi vitali dell'interessato o di terzi</li>
                <li><strong>Motivi di interesse pubblico:</strong> per finalità di medicina preventiva, diagnosi e assistenza sanitaria</li>
              </ul>
            </div>

            <div className="privacy-block">
              <h3>6. Destinatari dei Dati</h3>
              <p>
                I dati personali possono essere comunicati a:
              </p>
              <ul>
                <li>Personale sanitario e amministrativo autorizzato</li>
                <li>Società di servizi informatici per la manutenzione del sito e dei sistemi</li>
                <li>Consulenti e professionisti (commercialisti, avvocati)</li>
                <li>Autorità pubbliche e organi di vigilanza, quando richiesto dalla legge</li>
                <li>Compagnie assicurative per pratiche di rimborso</li>
              </ul>
              <p>
                I dati non saranno diffusi né trasferiti al di fuori dell'Unione Europea senza un'adeguata base giuridica.
              </p>
            </div>

            <div className="privacy-block">
              <h3>7. Periodo di Conservazione</h3>
              <p>
                I dati personali sono conservati per il tempo necessario alle finalità per cui sono stati raccolti:
              </p>
              <ul>
                <li><strong>Dati sanitari:</strong> conservati per 10 anni dalla data dell'ultima prestazione, come previsto dalla normativa vigente</li>
                <li><strong>Dati amministrativi e contabili:</strong> conservati per 10 anni ai fini fiscali</li>
                <li><strong>Dati di navigazione:</strong> conservati per un periodo massimo di 12 mesi</li>
              </ul>
            </div>

            <div className="privacy-block">
              <h3>8. Diritti dell'Interessato</h3>
              <p>
                L'interessato ha diritto di:
              </p>
              <ul>
                <li><strong>Accesso:</strong> ottenere la conferma dell'esistenza o meno di dati personali che lo riguardano</li>
                <li><strong>Rettifica:</strong> ottenere la correzione dei dati inesatti</li>
                <li><strong>Cancellazione:</strong> ottenere la cancellazione dei dati (diritto all'oblio)</li>
                <li><strong>Limitazione:</strong> ottenere la limitazione del trattamento</li>
                <li><strong>Portabilità:</strong> ricevere i dati in formato strutturato e trasmetterli ad altro titolare</li>
                <li><strong>Opposizione:</strong> opporsi al trattamento per motivi legittimi</li>
                <li><strong>Revoca del consenso:</strong> revocare il consenso in qualsiasi momento, senza pregiudicare la liceità del trattamento basata sul consenso prestato prima della revoca</li>
                <li><strong>Reclamo:</strong> proporre reclamo all'Autorità Garante per la Protezione dei Dati Personali</li>
              </ul>
              <p>
                Per esercitare i propri diritti, l'interessato può contattarci ai recapiti indicati al punto 1.
              </p>
            </div>

            <div className="privacy-block">
              <h3>9. Sicurezza dei Dati</h3>
              <p>
                Adottiamo misure tecniche e organizzative adeguate per proteggere i dati personali da 
                accesso non autorizzato, divulgazione, modifica o distruzione. Tra le misure adottate:
              </p>
              <ul>
                <li>Cifratura delle connessioni (HTTPS)</li>
                <li>Controlli di accesso ai sistemi</li>
                <li>Formazione del personale sulla protezione dei dati</li>
                <li>Backup regolari dei dati</li>
                <li>Procedure di gestione delle violazioni dei dati</li>
              </ul>
            </div>
          </div>

          {/* Cookie Policy */}
          <div className="privacy-section">
            <div className="privacy-icon-header">
              <FontAwesomeIcon icon={faCookie} />
              <h2>Cookie Policy</h2>
            </div>

            <div className="privacy-block">
              <h3>1. Cosa Sono i Cookie</h3>
              <p>
                I cookie sono piccoli file di testo che vengono memorizzati sul dispositivo dell'utente 
                durante la navigazione su un sito web. I cookie possono essere utilizzati per diverse 
                finalità, come migliorare l'esperienza di navigazione, ricordare le preferenze dell'utente 
                e analizzare il traffico del sito.
              </p>
            </div>

            <div className="privacy-block">
              <h3>2. Tipologie di Cookie Utilizzati</h3>
              
              <h4>Cookie Tecnici (Necessari)</h4>
              <p>
                Questi cookie sono essenziali per il corretto funzionamento del sito. Non possono essere 
                disabilitati e non richiedono il consenso dell'utente.
              </p>
              <ul>
                <li><strong>Cookie di sessione:</strong> permettono la navigazione e l'utilizzo delle funzionalità del sito</li>
                <li><strong>Cookie di preferenze:</strong> memorizzano le scelte dell'utente (es. preferenze sui cookie)</li>
              </ul>

              <h4>Cookie Analitici</h4>
              <p>
                Questi cookie ci aiutano a capire come i visitatori interagiscono con il sito, raccogliendo 
                informazioni in forma anonima. Questi dati vengono utilizzati per migliorare il funzionamento 
                del sito.
              </p>
              <ul>
                <li>Numero di visitatori</li>
                <li>Pagine più visitate</li>
                <li>Tempo di permanenza sul sito</li>
                <li>Modalità di arrivo al sito (motori di ricerca, link diretti, ecc.)</li>
              </ul>

              <h4>Cookie di Marketing</h4>
              <p>
                Questi cookie vengono utilizzati per tracciare i visitatori attraverso i siti web e mostrare 
                annunci pertinenti e coinvolgenti. Possono anche limitare il numero di volte che un annuncio 
                viene visualizzato e misurare l'efficacia delle campagne pubblicitarie.
              </p>
            </div>

            <div className="privacy-block">
              <h3>3. Cookie di Terze Parti</h3>
              <p>
                Il nostro sito può utilizzare servizi di terze parti che installano i propri cookie:
              </p>
              <ul>
                <li><strong>Google Analytics:</strong> per l'analisi statistica delle visite (se abilitato)</li>
                <li><strong>Google Maps:</strong> per la visualizzazione delle mappe e delle indicazioni stradali</li>
                <li><strong>Social Media:</strong> per la condivisione dei contenuti sui social network</li>
              </ul>
              <p>
                Questi cookie sono soggetti alle rispettive privacy policy dei fornitori di servizi.
              </p>
            </div>

            <div className="privacy-block">
              <h3>4. Durata dei Cookie</h3>
              <p>
                I cookie possono essere:
              </p>
              <ul>
                <li><strong>Cookie di sessione:</strong> vengono cancellati automaticamente alla chiusura del browser</li>
                <li><strong>Cookie persistenti:</strong> rimangono memorizzati sul dispositivo per un periodo determinato (di solito 12 mesi) o fino alla loro cancellazione manuale</li>
              </ul>
            </div>

            <div className="privacy-block">
              <h3>5. Gestione dei Cookie</h3>
              <p>
                L'utente può gestire le proprie preferenze sui cookie in qualsiasi momento attraverso:
              </p>
              <ul>
                <li><strong>Banner dei cookie:</strong> al primo accesso al sito, è possibile accettare, rifiutare o personalizzare i cookie</li>
                <li><strong>Impostazioni del browser:</strong> è possibile configurare il browser per bloccare o eliminare i cookie</li>
              </ul>
              
              <h4>Come disabilitare i cookie tramite browser:</h4>
              <ul>
                <li><strong>Google Chrome:</strong> Impostazioni &gt; Privacy e sicurezza &gt; Cookie e altri dati dei siti</li>
                <li><strong>Mozilla Firefox:</strong> Preferenze &gt; Privacy e sicurezza &gt; Cookie e dati dei siti web</li>
                <li><strong>Safari:</strong> Preferenze &gt; Privacy &gt; Blocca tutti i cookie</li>
                <li><strong>Microsoft Edge:</strong> Impostazioni &gt; Privacy, ricerca e servizi &gt; Cookie e autorizzazioni del sito</li>
              </ul>
              <p>
                <strong>Nota:</strong> disabilitare i cookie potrebbe limitare alcune funzionalità del sito.
              </p>
            </div>

            <div className="privacy-block">
              <h3>6. Aggiornamenti</h3>
              <p>
                Questa Cookie Policy può essere aggiornata periodicamente. Le modifiche saranno pubblicate 
                su questa pagina con l'indicazione della data di ultimo aggiornamento.
              </p>
            </div>
          </div>

          {/* Contact Section */}
          <div className="privacy-contact">
            <h3>Hai domande sulla privacy?</h3>
            <p>
              Se hai domande o dubbi riguardo alla nostra Privacy e Cookie Policy, o vuoi esercitare 
              i tuoi diritti, non esitare a contattarci:
            </p>
            <div className="privacy-contact-info">
              <div className="privacy-contact-item">
                <FontAwesomeIcon icon={faPhone} />
                <div>
                  <a href="tel:+393701627395">+39 370 162 7395</a>
                  <a href="tel:+390917669253">+39 091 766 9253</a>
                </div>
              </div>
              <div className="privacy-contact-item">
                <FontAwesomeIcon icon={faEnvelope} />
                <a href="mailto:centrodiotorino.mattina@gmail.com">centrodiotorino.mattina@gmail.com</a>
              </div>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicyPage;
